import React from 'react';
import Clickable from 'src/app/atoms/Clickable/Clickable';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import StarFilled from 'src/app/icons/Custom/Star/StarFilled';

interface ReviewStarsProps {
  href?: string;
}

const ReviewStars = ({ href = '/reviews' }: ReviewStarsProps): JSX.Element => (
  <Clickable href={href}>
    <Stack
      direction='column'
      gap='spacing-xs'
    >
      <Stack
        gap='spacing-md'
        align='center'
        justify='flex-start'
      >
        <Stack>
          {Array.from({ length: 5 }).map((_, index) => (
            <StarFilled key={index} />
          ))}
        </Stack>
        <Typography
          size='md'
          type='paragraph'
          fontWeight='font-weight-semibold'
        >
          4.8
        </Typography>
      </Stack>
      <Typography
        size='md'
        type='paragraph'
        fontWeight='font-weight-medium'
        whiteSpace='break-spaces'
        color='text-tertiary'
      >
        {' '}
        from 80k+ ratings
      </Typography>
    </Stack>
  </Clickable>
);

export default ReviewStars;
